import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://aadhavacademy.com/api/coaches/index.php';

// Async thunk to fetch coaches (GET request)
export const fetchCoaches = createAsyncThunk('coaches/fetchCoaches', async (params) => {
  try {
    const { search, page, limit } = params;
    const response = await axios.get(API_URL, {
      params: { search, page, limit }
    });
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
});

// Add a new coach (POST request)
export const addCoach = createAsyncThunk('coaches/addCoach', async (coachData) => {
  try {
    const response = await axios.post(API_URL, coachData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
});

// Update an existing coach (PUT request)
export const updateCoach = createAsyncThunk('coaches/updateCoach', async ({ id, coachData }) => {
  try {
    const response = await axios.put(`${API_URL}?id=${id}`, coachData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
});

// Delete a coach (DELETE request)
export const deleteCoach = createAsyncThunk('coaches/deleteCoach', async (id) => {
  try {
    const response = await axios.delete(`${API_URL}?id=${id}`);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
});

// Slice definition
const coachSlice = createSlice({
  name: 'coaches',
  initialState: {
    coaches: [],
    total: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
    selectedCoach: null, // For edit/view
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedCoach: (state, action) => {
      state.selectedCoach = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCoaches.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCoaches.fulfilled, (state, action) => {
        state.coaches = action.payload.coaches || [];
        state.total = action.payload.total || 0;
        state.totalPages = action.payload.totalPages || 0;
        state.currentPage = action.payload.currentPage || 1;
        state.loading = false;
      })
      .addCase(fetchCoaches.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(addCoach.fulfilled, (state, action) => {
        state.coaches.push(action.payload);
      })
      .addCase(updateCoach.fulfilled, (state, action) => {
        const updatedCoach = action.payload;
        state.coaches = state.coaches.map((coach) =>
          coach.id === updatedCoach.id ? updatedCoach : coach
        );
      })
      .addCase(deleteCoach.fulfilled, (state, action) => {
        state.coaches = state.coaches.filter((coach) => coach.id !== action.payload.id);
      });
  }
});

// Export actions
export const { setCurrentPage, setSelectedCoach } = coachSlice.actions;

// Export reducer
export default coachSlice.reducer;
